import { mobileApi, mobileCapabilities, mobileEpoch, mobileOwner, reportMobileError } from './mobileCommerce';
export interface WishlistProduct { id?: string; sku?: string; name: string; price: string | number; imageUrl: string; slug: string; brand?: string; diameter?: string; width?: string; et?: string; pcd?: string; color?: string; stock?: number; withdrawn?: boolean; }
class WishlistStore {
    private products: WishlistProduct[] = [];
    private listeners = new Set<() => void>();
    private account: string | null = null;
    private synced = false;
    private pending = 0;
    private sequence: Promise<unknown> = Promise.resolve();
    constructor() {
        if (typeof window === 'undefined') return;
        this.readGuest();
        window.addEventListener('mobile-account-changed', () => { this.account = mobileOwner(); this.synced = false; this.products = []; if (!this.account) this.readGuest(); this.notify(); });
        window.addEventListener('storage', e => { if (e.key === 'felgocar-wishlist' && !this.account) { this.readGuest(); this.notify(); } });
    }
    private readGuest() { try { this.products = JSON.parse(localStorage.getItem('felgocar-wishlist') || '[]'); } catch { this.products = []; } }
    subscribe(listener: () => void) { this.listeners.add(listener); return () => { this.listeners.delete(listener); }; }
    private notify() { this.listeners.forEach(l => l()); if (!this.account && typeof localStorage !== 'undefined') localStorage.setItem('felgocar-wishlist', JSON.stringify(this.products)); }
    private fromServer(rows: any[]): WishlistProduct[] { return rows.map(row => row.product ? ({ ...row.product, id: String(row.id), price: row.product.price, imageUrl: row.product.images?.[0] || row.product.imageUrl || '', diameter: row.product.size, pcd: row.product.boltPattern, et: row.product.offset }) : ({ id: String(row.id), slug: String(row.id), name: 'Produkt wycofany', price: 0, stock: 0, imageUrl: '', withdrawn: true })); }
    async syncAccount() {
        const current = mobileEpoch(), account = mobileOwner();
        if (this.pending) return;
        if (account !== this.account) { this.account = account; this.synced = false; this.products = []; this.notify(); }
        if (!account) return;
        const cap = await mobileCapabilities();
        if (current !== mobileEpoch()) return;
        this.synced = !!cap.features.favorites;
        if (!this.synced) return;
        const data = await mobileApi('/favorites');
        if (current !== mobileEpoch()) return;
        this.products = this.fromServer(data.favorites); this.notify();
    }
    getProducts() { return [...this.products]; }
    getCount() { return this.products.length; }
    isInWishlist(slug: string) { return this.products.some(p => p.slug === slug); }
    private change(product: WishlistProduct, enabled: boolean) {
        const started = mobileEpoch(), account = this.account, before = this.products;
        this.products = enabled ? [...before.filter(p => p.slug !== product.slug), product] : before.filter(p => p.slug !== product.slug); this.notify();
        if (!account) return;
        this.pending++;
        const job = async () => {
            if (started !== mobileEpoch()) { this.pending--; return; }
            try {
                const cap = await mobileCapabilities();
                if (started !== mobileEpoch()) return;
                if (!cap.features.favorites || !product.id) throw new Error('Synchronizacja ulubionych nie jest teraz dostępna.');
                const data = await mobileApi('/favorites/' + encodeURIComponent(String(product.id)), { method: 'PUT', body: JSON.stringify({ enabled }) });
                if (started !== mobileEpoch()) return;
                if (this.pending === 1) { this.products = this.fromServer(data.favorites); this.notify(); }
            } catch (error) { if (started === mobileEpoch()) { reportMobileError(error); } } finally { this.pending--; if (started === mobileEpoch() && !this.pending) await this.syncAccount().catch(reportMobileError); }
        };
        this.sequence = this.sequence.then(job, job);
    }
    toggle(product: WishlistProduct) { const enabled = !this.isInWishlist(product.slug); this.change(product, enabled); return enabled; }
    remove(slug: string) { const product = this.products.find(p => p.slug === slug); if (product) this.change(product, false); }
    clear() { [...this.products].forEach(p => this.change(p, false)); }
}
export const wishlistStore = new WishlistStore();
